import {Observable, Subscription} from 'rxjs';

import IFrameStore from '../Interfaces/IFrameStore';

const subscribeToSettingsCloseTap = (
    captionButtonTap$: Observable<void>,
    frameStore: IFrameStore
): Subscription =>
    captionButtonTap$
        .subscribe(() => frameStore.actions.closeSettings());

export default subscribeToSettingsCloseTap;